export type RouteType = {
  url: string;
  meta: Record<string, any> & {
    isPage: boolean | "only-desktop";
    // in mobile
    translation?: string;
  };
};
type Route = {
  [key: string]: Route | RouteType;
};

export const DashboardRoutes = {
  // INIT ROUTE
  root: {
    url: "/",
    meta: { isPage: true },
  },
  login: {
    url: "/login",
    meta: { isPage: false },
  },
  logout: {
    url: "/logout",
    meta: { isPage: false },
  },
  oAuthCallback: {
    url: "/oauth_callback",
    meta: { isPage: true },
  },
  settlement: {
    root: {
      url: "/settlement",
      meta: { isPage: true, title: "settlement.title" },
    },
    create: {
      url: "/settlement/create/:step/:code?",
      meta: { isPage: true },
    },
    transaction: {
      url: "/settlement/transaction",
      meta: { isPage: true, translation: "settlement.transaction.title" },
    },
    overview: {
      url: "/settlement/overview",
      meta: { isPage: true, translation: "overview.settlementCard.title" },
    },
    report: {
      list: {
        url: "/settlement/report",
        meta: { isPage: true, translation: "settlement.report.title" },
      },
      detail: {
        url: "/settlement/report/:code",
        meta: { isPage: true },
      },
    },
    id: {
      url: "/settlement/id",
      meta: { isPage: true, translation: "settlement.id.title" },
    },
    createId: {
      url: "/settlement/id/create",
      meta: { isPage: false },
    },
  },
  mySale: {
    root: {
      url: "/mySale",
      meta: { isPage: true },
    },
    report: {
      url: "/mySale/report",
      meta: { isPage: true, translation: "mySale.tabs.report.title" },
    },
    requestWithdraw: {
      url: "/mySale/requestWithdraw",
      meta: { isPage: false },
    },
    balanceAndWithdraw: {
      url: "/mySale/balanceAndWithdraw",
      meta: { isPage: true, translation: "mySale.tabs.balance&withdraws" },
    },
  },
  myShop: {
    root: {
      url: "/myShop",
      meta: { isPage: true },
    },
    product: {
      root: {
        url: "/myShop/product",
        meta: { isPage: true },
      },
      create: {
        url: "/myShop/product/create",
        meta: { isPage: false },
      },
      createBulk: {
        url: "/myShop/product/createBulk",
        meta: { isPage: true },
      },

      edit: {
        url: "/myShop/product/edit/:code",
        meta: { isPage: false },
      },
      list: {
        url: "/myShop/product/list",
        meta: { isPage: true, translation: "shop.tabs.product" },
      },
    },
    invoice: {
      root: {
        url: "/myShop/invoice",
        meta: { isPage: true },
      },
      correction: {
        url: "/myShop/invoice/correction/:code",
        meta: { isPage: false },
      },
      create: {
        url: "/myShop/invoice/create",
        meta: { isPage: false },
      },
      edit: {
        url: "/myShop/invoice/edit/:code",
        meta: { isPage: false },
      },
      // did not used anywhere
      details: {
        url: "/myShop/invoice/:code",
        meta: { isPage: true },
      },
      list: {
        url: "/myShop/invoice/list",
        meta: { isPage: true, translation: "shop.tabs.invoice" },
      },
      show: {
        url: "/myShop/invoice/show",
        meta: { isPage: true },
      },
    },
    customer: {
      root: {
        url: "/myShop/customer",
        meta: { isPage: true },
      },
      create: {
        url: "/myShop/customer/create",
        meta: { isPage: false },
      },
      createBulk: {
        url: "/myShop/customer/createBulk",
        meta: { isPage: true },
      },
      // have page but did not use it
      edit: {
        url: "/myShop/customer/edit/:code",
        meta: { isPage: true },
      },
      list: {
        url: "/myShop/customer/list",
        meta: { isPage: true, translation: "shop.tabs.customer" },
      },
    },
    coupon: {
      root: {
        url: "/myShop/coupon/",
        meta: { isPage: true },
      },
      create: {
        url: "/myShop/coupon/create",
        meta: { isPage: false },
      },
      // did not used anywhere
      detail: {
        url: "/myShop/coupon/detail/:code",
        meta: { isPage: true },
      },
      edit: {
        url: "/myShop/coupon/edit/:code",
        meta: { isPage: false },
      },
      list: {
        url: "/myShop/coupon/list",
        meta: { isPage: true, translation: "shop.tabs.coupon" },
      },
    },
    bnpl: {
      root: {
        url: "/myShop/bnpl",
        meta: {
          isPage: true,
          translation: "shop.tabs.bnpl.root",
        },
      },
      activation: {
        root: {
          url: "/myShop/bnpl/activation",
          meta: {
            isPage: true,
            translation: "shop.tabs.bnpl.activation",
          },
        },
      },
      list: {
        root: {
          url: "/myShop/bnpl/list",
          meta: {
            isPage: true,
            translation: "shop.bnpl.ordersList.title",
            // translation: "shop.tabs.bnpl.list",
          },
        },
        details: {
          root: {
            url: "/myShop/bnpl/list/details/:code",
            meta: {
              isPage: false,
            },
          },
        },
      },
      financialCalender: {
        root: {
          url: "/myShop/bnpl/financial-calender",
          meta: {
            isPage: true,
            translation: "common.financialCalender",
          },
        },
      },
      plans: {
        root: {
          url: "/myShop/bnpl/plans",
          meta: {
            isPage: true,
            translation: "shop.tabs.bnpl.plans",
          },
        },
        addPlan: {
          root: {
            url: "/myShop/bnpl/plans/add-plan",
            meta: {
              isPage: false,
            },
          },
        },
      },
      manage: {
        root: {
          url: "/myShop/bnpl/manage",
          meta: {
            isPage: true,
            translation: "shop.tabs.bnpl.manage",
          },
        },
        creditWalletReport: {
          root: {
            url: "/myShop/bnpl/manage/credit-wallet-report",
            meta: {
              isPage: false,
            },
          },
        },
      },
    },
  },
  connections: {
    root: {
      url: "/connections",
      meta: { isPage: true },
    },
    // did not used anywhere
    document: {
      root: {
        url: "/connections/document",
        meta: { isPage: true },
      },
    },
    oauth: {
      root: {
        url: "/connections/oauth",
        meta: { isPage: true, translation: "connections.mobileMenu.oauth" },
      },
      // did not used anywhere
      create: {
        url: "/connections/oauth/create",
        meta: { isPage: true },
      },
      // did not used anywhere
      edit: {
        url: "/connections/oauth/edit/:clientId",
        meta: { isPage: true },
      },
      // did not used anywhere
      renew: {
        url: "/connections/oauth/renew/:clientId",
        meta: { isPage: true },
      },
      // did not used anywhere
      show: {
        url: "/connections/oauth/show",
        meta: { isPage: true },
      },
    },

    developers: {
      root: {
        url: "/connections/developers",
        meta: { isPage: true, translation: "connections.mobileMenu.developers" },
      },
      tokensList: {
        url: "/connections/developers/tokens",
        meta: { isPage: false },
      },
    },
    plugins: {
      root: {
        url: "/connections/plugins",
        meta: { isPage: true, translation: "connections.mobileMenu.plugins" },
      },
      details: {
        url: "/connections/plugins/details/:name",
        meta: { isPage: false },
      },
    },
  },
  home: {
    root: {
      url: "/home",
      meta: { isPage: true },
    },
    overview: {
      url: "/home/overview",
      meta: { isPage: true },
    },
    messages: {
      url: "/home/messages",
      meta: { isPage: false },
    },
    changeLog: {
      url: "/home/changeLog",
      meta: { isPage: false },
    },
  },
  // this route are deleted, first need to delete files
  platform: {
    root: {
      url: "/platform",
      meta: { isPage: true },
    },
    list: {
      url: "/platform/list",
      meta: { isPage: true },
    },
    create: {
      url: "/platform/create",
      meta: { isPage: true },
    },
    detail: {
      url: "/platform/detail/:clientId",
      meta: { isPage: true },
    },
    edit: {
      url: "/platform/edit/:clientId",
      meta: { isPage: true },
    },
    renew: {
      url: "/platform/renew/:clientId",
      meta: { isPage: true },
    },
    show: {
      url: "/platform/show",
      meta: { isPage: true },
    },
    clientRegister: {
      root: {
        url: "/platform/:clientId/clientRegister",
        meta: { isPage: true },
      },
      create: {
        url: "/platform/:clientId/clientRegister/create",
        meta: { isPage: true },
      },
      edit: {
        url: "/platform/:clientId/clientRegister/edit/:code",
        meta: { isPage: true },
      },
      detail: {
        url: "/platform/:clientId/clientRegister/detail/:code",
        meta: { isPage: true },
      },
      getLink: {
        url: "/platform/:clientId/clientRegister/getLink",
        meta: { isPage: true },
      },
      list: {
        url: "/platform/:clientId/clientRegister/list",
        meta: { isPage: true },
      },
    },
    payment: {
      root: {
        url: "/platform/:clientId/payment",
        meta: { isPage: true },
      },
      detail: {
        url: "/platform/:clientId/payment/detail/:code",
        meta: { isPage: true },
      },
      list: {
        url: "/platform/:clientId/payment/list",
        meta: { isPage: true },
      },
    },
    user: {
      root: {
        url: "/platform/:clientId/user",
        meta: { isPage: true },
      },
      detail: {
        url: "/platform/:clientId/user/detail/:code",
        meta: { isPage: true },
      },
      list: {
        url: "/platform/:clientId/user/list",
        meta: { isPage: true },
      },
    },
  },
  user: {
    root: {
      url: "/user",
      meta: { isPage: true },
    },
    // this route did not use anywhere
    disable2fa: {
      url: "/user/settings/disable2fa",
      meta: { isPage: true },
    },
    // this route did not use anywhere
    enable2fa: {
      url: "/user/settings/enable2fa",
      meta: { isPage: true },
    },
    referral: {
      url: "/user/referral",
      meta: { isPage: false },
    },
    upgrade: {
      url: "/user/upgrade",
      meta: { isPage: true },
    },
  },
  profile: {
    root: {
      url: "/profile",
      meta: { isPage: "only-desktop" },
    },
    mRoot: {
      url: "/profile/index",
      meta: { isPage: false },
    },
    client: {
      url: "/profile/client",
      meta: { isPage: "only-desktop" },
    },
    "2fa": {
      url: "/profile/2fa",
      meta: { isPage: "only-desktop" },
    },
    m2fa: {
      root: {
        url: "/profile/m2fa",
        meta: { isPage: true },
      },
      menu: {
        url: "/profile/m2fa/index",
        meta: { isPage: false },
      },
      loginEnable: {
        url: "/profile/m2fa/loginEnable",
        meta: { isPage: false },
      },
      loginDisable: {
        url: "/profile/m2fa/loginDisable",
        meta: { isPage: false },
      },
    },
    display: {
      url: "/profile/display",
      meta: { isPage: "only-desktop" },
    },
    detail: {
      url: "/profile/detail",
      meta: { isPage: "only-desktop" },
    },
    social: {
      url: "/profile/social",
      meta: { isPage: "only-desktop" },
    },
    messaging: {
      url: "/profile/messaging",
      meta: { isPage: "only-desktop" },
    },
    password: {
      url: "/profile/password",
      meta: { isPage: "only-desktop" },
    },
  },
  settings: {
    root: {
      url: "/settings",
      meta: { isPage: "only-desktop" },
    },
    mRoot: {
      url: "/settings/index",
      meta: { isPage: false },
    },
    bank: {
      root: {
        url: "/settings/bank",
        meta: { isPage: "only-desktop" },
      },
      edit: {
        url: "/settings/bank/edit",
        meta: { isPage: false },
      },
    },
    mEditBank: {
      shaba: {
        url: "/settings/mBank/shaba",
        meta: { isPage: false },
      },
    },
    business: {
      root: {
        url: "/settings/business",
        meta: { isPage: "only-desktop" },
      },
      edit: {
        url: "/settings/business/edit",
        meta: { isPage: false },
      },
    },
    mEditBusiness: {
      root: {
        url: "/settings/mBusiness",
        meta: { isPage: true },
      },
      name: {
        url: "/settings/mBusiness/name",
        meta: { isPage: false },
      },
      description: {
        url: "/settings/mBusiness/description",
        meta: { isPage: false },
      },
      state: {
        url: "/settings/mBusiness/state",
        meta: { isPage: false },
      },
      city: {
        url: "/settings/mBusiness/city",
        meta: { isPage: false },
      },
      address: {
        url: "/settings/mBusiness/address",
        meta: { isPage: false },
      },
      phone: {
        url: "/settings/mBusiness/phone",
        meta: { isPage: false },
      },
      postalCode: {
        url: "/settings/mBusiness/postalCode",
        meta: { isPage: false },
      },
      site: {
        url: "/settings/mBusiness/site",
        meta: { isPage: false },
      },
      taxCode: {
        url: "/settings/mBusiness/taxCode",
        meta: { isPage: false },
      },
      businessRegistrationStatus: {
        url: "/settings/mBusiness/businessRegistrationStatus",
        meta: { isPage: false },
      },
      officialBusinessName: {
        url: "/settings/mBusiness/officialName",
        meta: { isPage: false },
      },
      officialBusinessRegistrationDate: {
        url: "/settings/mBusiness/officialRegistrationDate",
        meta: { isPage: false },
      },
      officialBusinessSabtNumber: {
        url: "/settings/mBusiness/officialSabtNumber",
        meta: { isPage: false },
      },
      officialBusinessbNationalCode: {
        url: "/settings/mBusiness/officialsbNationalCode",
        meta: { isPage: false },
      },
      officialBusinessEconomicCode: {
        url: "/settings/mBusiness/officialEconomicCode",
        meta: { isPage: false },
      },
      officialBusinessDocument: {
        url: "/settings/mBusiness/officialIntroductionLetter",
        meta: { isPage: false },
      },
    },
    personal: {
      root: {
        url: "/settings/personal",
        meta: { isPage: "only-desktop" },
      },
      edit: {
        url: "/settings/personal/edit",
        meta: { isPage: false },
      },
    },
    mEditPersonal: {
      root: {
        url: "/settings/mPersonal",
        meta: { isPage: true },
      },
      name: {
        url: "/settings/mPersonal/name",
        meta: { isPage: false },
      },
      lastName: {
        url: "/settings/mPersonal/lastName",
        meta: { isPage: false },
      },
      fatherName: {
        url: "/settings/mPersonal/fatherName",
        meta: { isPage: false },
      },
      phoneNumber: {
        url: "/settings/mPersonal/phoneNumber",
        meta: { isPage: false },
      },
      birthDate: {
        url: "/settings/mPersonal/birthDate",
        meta: { isPage: false },
      },
      birthCertificateNumber: {
        url: "/settings/mPersonal/birthCertificateNumber",
        meta: { isPage: false },
      },
      nationalCode: {
        url: "/settings/mPersonal/nationalCode",
        meta: { isPage: false },
      },
      email: {
        url: "/settings/mPersonal/email",
        meta: { isPage: false },
      },
      documents: {
        url: "/settings/mPersonal/documents",
        meta: { isPage: false },
      },
    },
    terminal: {
      url: "/settings/terminal",
      meta: { isPage: "only-desktop" },
    },
    shop:{
      url: "/settings/shop",
      meta: { isPage: "only-desktop" },
    }
  },
  register: {
    root: {
      url: "/register",
      meta: { isPage: true },
    },
    personal: {
      url: "/register/personal",
      meta: { isPage: "only-desktop" },
    },
    mEditPersonal: {
      root: {
        url: "/register/mPersonal",
        meta: { isPage: true },
      },
      name: {
        url: "/register/mPersonal/name",
        meta: { isPage: false },
      },
      lastName: {
        url: "/register/mPersonal/lastName",
        meta: { isPage: false },
      },
      fatherName: {
        url: "/register/mPersonal/fatherName",
        meta: { isPage: false },
      },
      phoneNumber: {
        url: "/register/mPersonal/phoneNumber",
        meta: { isPage: false },
      },
      birthDate: {
        url: "/register/mPersonal/birthDate",
        meta: { isPage: false },
      },
      birthCertificateNumber: {
        url: "/register/mPersonal/birthCertificateNumber",
        meta: { isPage: false },
      },
      nationalCode: {
        url: "/register/mPersonal/nationalCode",
        meta: { isPage: false },
      },
      email: {
        url: "/register/mPersonal/email",
        meta: { isPage: false },
      },
      documents: {
        url: "/register/mPersonal/documents",
        meta: { isPage: false },
      },
    },
    business: {
      url: "/register/business",
      meta: { isPage: "only-desktop" },
    },
    mEditBusiness: {
      root: {
        url: "/register/mBusiness",
        meta: { isPage: true },
      },
      name: {
        url: "/register/mBusiness/name",
        meta: { isPage: false },
      },
      description: {
        url: "/register/mBusiness/description",
        meta: { isPage: false },
      },
      state: {
        url: "/register/mBusiness/state",
        meta: { isPage: false },
      },
      city: {
        url: "/register/mBusiness/city",
        meta: { isPage: false },
      },
      address: {
        url: "/register/mBusiness/address",
        meta: { isPage: false },
      },
      phone: {
        url: "/register/mBusiness/phone",
        meta: { isPage: false },
      },
      postalCode: {
        url: "/register/mBusiness/postalCode",
        meta: { isPage: false },
      },
      site: {
        url: "/register/mBusiness/site",
        meta: { isPage: false },
      },
      taxCode: {
        url: "/register/mBusiness/taxCode",
        meta: { isPage: false },
      },
      businessRegistrationStatus: {
        url: "/register/mBusiness/businessRegistrationStatus",
        meta: { isPage: false },
      },
      officialBusinessName: {
        url: "/register/mBusiness/officialName",
        meta: { isPage: false },
      },
      officialBusinessRegistrationDate: {
        url: "/register/mBusiness/officialRegistrationDate",
        meta: { isPage: false },
      },
      officialBusinessSabtNumber: {
        url: "/register/mBusiness/officialSabtNumber",
        meta: { isPage: false },
      },
      officialBusinessbNationalCode: {
        url: "/register/mBusiness/officialsbNationalCode",
        meta: { isPage: false },
      },
      officialBusinessEconomicCode: {
        url: "/register/mBusiness/officialEconomicCode",
        meta: { isPage: false },
      },
      officialBusinessDocument: {
        url: "/register/mBusiness/officialIntroductionLetter",
        meta: { isPage: false },
      },
    },
    bank: {
      url: "/register/bank",
      meta: { isPage: "only-desktop" },
    },
  },
  digitalAccount: {
    root: {
      url: "/digitalAccount",
      meta: { isPage: true },
    },
    home: {
      url: "/digitalAccount/home",
      meta: { isPage: true },
    },
    yourAccount: {
      url: "/digitalAccount/yourAccount",
      meta: { isPage: true, translation: "digitalAccount.menu.tabs.digitalAccount" },
    },
    jointAccount: {
      root: {
        url: "/digitalAccount/jointAccount",
        meta: { isPage: true },
      },
      khavarmianeh: {
        url: "/digitalAccount/jointAccount/khavarmianeh",
        meta: { isPage: true },
      },
    },
    agreement: {
      url: "/digitalAccount/:bank/agreement",
      meta: { isPage: true },
    },
    saman: {
      root: {
        url: "/digitalAccount/saman",
        meta: { isPage: true },
      },
      create: {
        url: "/digitalAccount/saman/create/:step",
        meta: { isPage: true },
      },
      accountConnection: {
        url: "/digitalAccount/saman/accountConnection",
        meta: { isPage: true },
      },
      newAccount: {
        root: { url: "/digitalAccount/saman/newAccount", meta: { isPage: true } },
        offline: { url: "/digitalAccount/saman/newAccount/offline", meta: { isPage: true } },
        bankFormGuide: { url: "/digitalAccount/saman/newAccount/bankFormGuide", meta: { isPage: true } },
      },
      getAccessAccount: {
        url: "/digitalAccount/saman/getAccessAccount",
        meta: { isPage: true },
      },
      access: {
        root: {
          url: "/digitalAccount/saman/access",
          meta: { isPage: true },
        },
        getInfo: {
          url: "/digitalAccount/saman/access/getInfo",
          meta: { isPage: true },
        },
        success: {
          url: "/digitalAccount/saman/access/success",
          meta: { isPage: true },
        },
        fail: {
          url: "/digitalAccount/saman/access/fail",
          meta: { isPage: true },
        },
        help: {
          url: "/digitalAccount/saman/access/help",
          meta: { isPage: true },
        },
      },
      turnOver: {
        url: "/digitalAccount/saman/turnOver",
        meta: { isPage: true, translation: "digitalAccount.menu.tabs.turnOver" },
      },
      request: {
        url: "/digitalAccount/saman/request",
        meta: { isPage: true, translation: "digitalAccount.menu.tabs.requestsTransferList" },
      },
    },
  },
} as const satisfies Route;

function extractValues(obj: typeof DashboardRoutes) {
  const values: RouteType[] = [];

  function recurse(currentObject: typeof DashboardRoutes): void {
    Object.keys(currentObject).forEach((key) => {
      const value = currentObject[key as keyof typeof DashboardRoutes];

      if (typeof value === "object" && value !== null) {
        if ("url" in value) {
          values.push(value);
        }
        recurse(value as unknown as typeof DashboardRoutes);
      }
    });
  }

  recurse(obj);
  return values;
}

export const dashboardRoutesArray = () => extractValues(DashboardRoutes);
